import './styles/templates/register-account.template.scss';

import FormComponent from './modules/form/form';
import GoBackComponent from './modules/go-back/go-back';

(function () {
  FormComponent.init();
  GoBackComponent.init();
})();